<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- <h3>Odds</h3> -->
      <div id="sidebar" style="width: 100px; padding-left: 2px">
        <h6>Select Sport</h6>
        <ul>
          <li>MLB</li>
        </ul>
      </div>

      <!-- full-width START here -->
      <div id="main-colum">
        <div class="column">
          <h4>Live Odds</h4>
          <table v-if="odds.mlb && odds.mlb.live && odds.mlb.live.data && odds.mlb.live.data.games.length">
            <thead>
              <tr class="bg-green">
                <th class="text-left" style="width: 25%">
                  In Progress
                </th>
                <th class="text-center" style="width: 10%">
                  Score
                </th>
                <th
                  v-for="h in odds.mlb.live.data.headers"
                  :key="h"
                  class="text-right"
                >
                  <a
                    v-if="h === 'BetAnySports'"
                    href="https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=220&AffUrlID=1606&LandingPageID=1"
                    target="_blank"
                  >BetAnySports</a>
                  <a
                    v-if="h === 'BetOnline'"
                    href="https://record.commissionkings.ag/_k86Ic18Yvp3lE-K0mpYMyWNd7ZgqdRLk/1/"
                    target="_blank"
                  >BetOnline</a>
                  <span v-if="h !== 'BetAnySports' && h !== 'BetOnline'">
                    {{ h }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody class="no-border">
              <template v-for="o in odds.mlb.live.data.games">
                <tr :key="o.awayCode" style="z-index: 1">
                  <td class="text-left no-border right-border bg-grey-10">
                    {{ o.awayTeam }}
                  </td>
                  <td class="text-center no-border right-border">
                    {{ o.awayScore }}
                  </td>
                  <td
                    v-for="(odd, index) in o.odds['Game']"
                    :key="index"
                    class="text-right no-border right-border"
                  >
                    <span v-if="oddType.value === 'spread'">
                      {{ odd.point_spread_away }}
                      {{ odd.point_spread_away_line }}
                    </span>
                    <span v-if="oddType.value === 'moneyline'">
                      {{ odd.money_line_away }}
                    </span>
                    <span v-if="oddType.value === 'total'">
                      {{ odd.total_number }}
                    </span>
                  </td>
                </tr>
                <tr :key="o.homeCode" style="border-bottom: 1px">
                  <td class="text-left bg-grey-10">
                    {{ o.homeTeam }}
                  </td>
                  <td class="text-center">
                    {{ o.homeScore }}
                  </td>
                  <td
                    v-for="(odd, index) in o.odds['Game']"
                    :key="index"
                    class="text-right"
                  >
                    <span v-if="oddType.value === 'spread'">
                      {{ odd.point_spread_home }}
                      {{ odd.point_spread_home_line }}
                    </span>
                    <span v-if="oddType.value === 'moneyline'">
                      {{ odd.money_line_home }}
                    </span>
                    <span v-if="oddType.value === 'total'">
                      {{ odd.total_number }} {{ odd.under_line }}
                    </span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div v-if="upcomingGames.length" class="column">
          <table>
            <thead>
              <tr class="bg-green">
                <th class="text-left" style="width: 25%">
                  Upcoming
                </th>
                <th class="text-center" style="width: 10%">
                  Date
                </th>
                <th
                  v-for="h in upcomingHeaders"
                  :key="h"
                  style="text-align: right"
                >
                  <a
                    v-if="h === 'BetOnline'"
                    href="https://record.commissionkings.ag/_k86Ic18Yvp3lE-K0mpYMyWNd7ZgqdRLk/1/"
                    target="_blank"
                  >BetOnline</a>

                  <a
                    v-if="h === 'BetAnySports'"
                    href="https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=220&AffUrlID=1606&LandingPageID=1"
                    target="_blank"
                  >BetAnySports</a>
                  <span v-if="h !== 'BetAnySports' && h !== 'BetOnline'">
                    {{ h }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody class="no-border">
              <template v-for="o in upcomingGames">
                <tr :key="o.awayCode">
                  <td class="text-left no-border right-border bg-grey-10">
                    {{ o.awayTeam }}
                  </td>
                  <td class="text-center no-border right-border">
                    {{ o.date }}
                  </td>
                  <td
                    v-for="(odd, index) in o.odds['Game']"
                    :key="index"
                    class="text-right no-border right-border"
                  >
                    <span v-if="oddType.value === 'spread'">
                      {{ odd.point_spread_away }}
                      {{ odd.point_spread_away_line }}
                    </span>
                    <span v-if="oddType.value === 'moneyline'">
                      {{ odd.money_line_away }}
                    </span>
                    <span v-if="oddType.value === 'total'">
                      {{ odd.total_number }} {{ odd.over_line }}
                    </span>
                  </td>
                </tr>
                <tr :key="o.homeCode" style="border-bottom: 1px">
                  <td class="text-left bg-grey-10">
                    {{ o.homeTeam }}
                  </td>
                  <td class="text-center">
                    {{ o.time }}
                  </td>
                  <td
                    v-for="(odd, index) in o.odds['Game']"
                    :key="index"
                    class="text-right"
                  >
                    <span v-if="oddType.value === 'spread'">
                      {{ odd.point_spread_home }}
                      {{ odd.point_spread_home_line }}
                    </span>
                    <span v-if="oddType.value === 'moneyline'">
                      {{ odd.money_line_home }}
                    </span>
                    <span v-if="oddType.value === 'total'">
                      {{ odd.total_number }} {{ odd.under_line }}
                    </span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <br />
        <a
          href="https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18"
          target="_top"
        >
          <img
            src="https://affiliates.betanysports.eu/tracking/banner.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18"
            hspace="0"
            vspace="0"
            border="0"
            alt="Bet at Betanysports.eu"
          /></a>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  components: {},
  data() {
    return {
      oddTypes: [
        { label: "Moneyline", value: "moneyline" },
        { label: "Spread", value: "spread" },
        { label: "Total", value: "total" },
      ],
      odds: this.$store.state.odds,
    };
  },
  computed: {
    upcomingHeaders() {
      return _.get(this.odds, "mlb.upcoming.data.headers", []);
    },
    upcomingGames() {
      return _.get(this.odds, "mlb.upcoming.data.games", []);
    },
  },
  created() {
    this.oddType = this.oddTypes[0];
    return this.loadData().then(() => {
      this.odds = this.$store.state.odds;
      console.log(JSON.stringify(this.odds));
    });
  },
  methods: {
    loadData() {
      return Promise.all([
        this.$store.dispatch("getUpcoming", "mlb"),
        this.$store.dispatch("getLive", "mlb"),
      ]);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Odds.vue?298514df